import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Text } from "@coveord/plasma-mantine";
import { memo } from "react";
var ref;
export var DefaultFacetItem = /*#__PURE__*/ memo(function(param) {
    var data = param.data, selected = param.selected, countFormatter = param.countFormatter;
    /*#__PURE__*/ return _jsx(Checkbox, {
        checked: selected,
        onChange: function() {
            return undefined;
        },
        "aria-hidden": true,
        label: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                data.label,
                data.count !== undefined ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsxs(Text, {
                        span: true,
                        color: "gray.6",
                        ml: "xs",
                        style: {
                            whiteSpace: "nowrap"
                        },
                        children: [
                            "(",
                            (ref = countFormatter === null || countFormatter === void 0 ? void 0 : countFormatter(data.count)) !== null && ref !== void 0 ? ref : data.count,
                            ")"
                        ]
                    })
                }) : null
            ]
        }),
        tabIndex: -1,
        style: {
            pointerEvents: "none",
            display: "flex"
        }
    });
});

//# sourceMappingURL=DefaultFacetItem.js.map